export default __webpack_public_path__ + "static/media/reglogin-m-bg-id.14d39e35.webp";